import React from "react";
import { Pagination } from "react-bootstrap";
import "./Pagination.css";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void; 
}


const PaginationComponent: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
  return (
    <div className="pagination-container d-flex align-items-center justify-content-center mt-4">
      <Pagination>
        {/* First Page */}
        <Pagination.First onClick={() => onPageChange(1)} disabled={currentPage === 1} />

        {/* Previous Page */}
        <Pagination.Prev onClick={() => onPageChange((currentPage - 1))} disabled={currentPage === 1} />

        {/* Page Info */}
        <Pagination.Item active>
          Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
        </Pagination.Item>

        {/* Next Page */}
        <Pagination.Next onClick={() => onPageChange((currentPage + 1))} disabled={currentPage === totalPages} />

        {/* Last Page */}
        <Pagination.Last onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages} />
      </Pagination>
    </div>
  );
};


export default PaginationComponent;
